var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGantryNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1699503043670,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2636,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 507.36037484m-477.21858845 0a477.21858845 477.21858845 0 1 0 954.4371769 0 477.21858845 477.21858845 0 1 0-954.4371769 0Z",
    fill: "#FFFFFF",
    "p-id": 2637
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.68980702 507.36037484c0 223.29853118 181.01166181 404.31019298 404.31019298 404.31019298s404.31019298-180.94538145 404.31019298-404.31019298-181.01166181-404.31019298-404.31019298-404.31019299-404.31019298 181.01166181-404.31019298 404.31019299z m0 0",
    fill: "#3AA173",
    "p-id": 2638
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M689.29996169 657.23683777l41.42522468-0.6628036v-31.03577833a19.38700515 19.38700515 0 1 1 38.75744022 0l-0.51367279 112.51091026a19.17159399 19.17159399 0 0 1-18.82362209 19.05560336 18.64135111 18.64135111 0 0 1-18.97275292-18.39279977l-0.44739242-33.65385254-57.51478196 0.67937368L626.33362015 627.09584429l36.96787052-17.96197743 25.98190092 48.05326064z m0 0",
    fill: "#FFFFFF",
    "p-id": 2639
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M602.58868135 607.42714761c-69.44524667 35.95709503-173.30657002 89.90930768-173.30657001 89.90930766s-21.70681774 6.14750334-33.63728245-3.91054121-38.11120672-83.39726235-38.11120672-83.39726235 48.05326064 45.88257887 54.31675461 42.65141134c96.4047829-49.95882098 334.99750704-178.47643806 334.99750704-178.47643806l22.61817268 46.64480301s-43.64561674 23.67865843-117.64763812 62.00527631c-3.31401797 1.65700898-44.73924267 22.28677088-49.16345666 24.5734433z m0 0",
    fill: "#D4EAF5",
    "p-id": 2640
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M760.88274995 444.84142573L422.70378565 620.76606995c-7.67195161 4.04310192-17.15004302 2.28667241-21.14343468-3.89397112L253.82142963 502.05794608c-3.96025149-6.19721362-0.86164467-14.46568846 6.84344712-18.47565022L654.40335241 278.52743363c7.70509179-4.04310192 17.1831832-2.31981259 21.16000476 3.89397114l92.12969972 143.92780066c3.96025149 6.18064352 0.89478485 14.44911838-6.81030694 18.4922203z m0 0",
    fill: "#FFFFFF",
    "p-id": 2641
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantryNormal);
export default __webpack_public_path__ + "static/media/gantry-normal.8e8a1d26049640dd483cea346f3ed590.svg";
export { ForwardRef as ReactComponent };